import { render, staticRenderFns } from "./ggd.vue?vue&type=template&id=2e1bac85&scoped=true&"
import script from "./ggd.vue?vue&type=script&lang=js&"
export * from "./ggd.vue?vue&type=script&lang=js&"
import style0 from "./ggd.vue?vue&type=style&index=0&id=2e1bac85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1bac85",
  null
  
)

export default component.exports